export default __webpack_public_path__ + "8d36efc517e68175f5287d5dc7503026.png";